module.exports = __webpack_public_path__ + "img/kontrast_logo_black.db6eb43e.png";